<div class="dock" *ngIf="!dismissed">

    <div class="dock-lead">
        <span class="dock-eyebrow">Your apps</span>
        <p class="dock-line">
            Use LIAM inside <strong>Claude</strong>, <strong>ChatGPT</strong> and <strong>Muse</strong><span
                class="dock-sub"> — one memory, shared across all three.</span>
        </p>
    </div>

    <div class="dock-actions">
        <a class="dock-btn gpt" [href]="chatgptAppUrl" target="_blank" rel="noopener">
            <span class="dock-ico">◍</span>
            <span class="dock-btn-text">
                <b><span class="lbl-full">Add in ChatGPT</span><span class="lbl-short">ChatGPT</span></b>
                <small>one click, from the app directory</small>
            </span>
        </a>

        <div class="dock-slot">
            <button type="button" class="dock-btn muse" (click)="togglePanel('muse', $event)"
                [class.is-open]="openPanel === 'muse'" [attr.aria-expanded]="openPanel === 'muse'">
                <span class="dock-ico">◆</span>
                <span class="dock-btn-text">
                    <b><span class="lbl-full">Connect Muse</span><span class="lbl-short">Muse</span></b>
                    <small>we copy the message for you</small>
                </span>
            </button>

            <div class="dock-details muse" *ngIf="openPanel === 'muse'">
                <p class="dock-details-head" [class.ok]="museCopyOk">
                    <ng-container *ngIf="museCopyOk; else copyItYourself">
                        <i class="fa-solid fa-check"></i> Copied to your clipboard
                    </ng-container>
                    <ng-template #copyItYourself>Copy this message</ng-template>
                </p>

                <pre class="dock-paste">{{ musePasteBlock }}</pre>

                <ol class="dock-steps">
                    <li>Open Muse and paste this as a new message</li>
                    <li>Tap <b>Connect</b> on the LIAM card it shows you</li>
                    <li>Sign in with Google</li>
                </ol>

                <div class="dock-details-actions">
                    <button type="button" class="dock-ghost" (click)="copyMuse($event)">
                        <i class="fa-solid" [ngClass]="copiedField === 'muse' ? 'fa-check' : 'fa-copy'"></i>
                        {{ copiedField === 'muse' ? 'Copied' : 'Copy again' }}
                    </button>
                    <a class="dock-go muse" [href]="museUrl" target="_blank" rel="noopener">
                        Open Muse <i class="fa-solid fa-arrow-right"></i>
                    </a>
                </div>
            </div>
        </div>

        <div class="dock-slot">
            <button type="button" class="dock-btn claude" (click)="togglePanel('claude', $event)"
                [class.is-open]="openPanel === 'claude'" [attr.aria-expanded]="openPanel === 'claude'">
                <span class="dock-ico">✳</span>
                <span class="dock-btn-text">
                    <b><span class="lbl-full">Connect Claude</span><span class="lbl-short">Claude</span></b>
                    <small>2 values to paste, shown here</small>
                </span>
            </button>

            <div class="dock-details claude" *ngIf="openPanel === 'claude'">
                <p class="dock-details-head">Claude asks for these two</p>

                <button type="button" class="dock-field" (click)="copyField('name', $event)">
                    <span class="dock-field-label">Name</span>
                    <span class="dock-field-value">{{ connectorName }}</span>
                    <span class="dock-field-copy">
                        <i class="fa-solid" [ngClass]="copiedField === 'name' ? 'fa-check' : 'fa-copy'"></i>
                        {{ copiedField === 'name' ? 'Copied' : 'Copy' }}
                    </span>
                </button>

                <button type="button" class="dock-field" (click)="copyField('url', $event)">
                    <span class="dock-field-label">Remote MCP server URL</span>
                    <span class="dock-field-value mono">{{ mcpUrl }}</span>
                    <span class="dock-field-copy">
                        <i class="fa-solid" [ngClass]="copiedField === 'url' ? 'fa-check' : 'fa-copy'"></i>
                        {{ copiedField === 'url' ? 'Copied' : 'Copy' }}
                    </span>
                </button>

                <ol class="dock-steps">
                    <li>Open Claude — the Add custom connector box is already up</li>
                    <li>Paste each value into its field, tap <b>Continue</b>, then <b>Add</b></li>
                    <li>Tap <b>Connect</b>, then sign in with Google</li>
                </ol>

                <div class="dock-details-actions">
                    <a class="dock-go claude" [href]="claudeConnectorUrl" target="_blank" rel="noopener">
                        Open Claude <i class="fa-solid fa-arrow-right"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>

    <button type="button" class="dock-close" (click)="dismiss()" aria-label="Hide">
        <i class="fa-solid fa-xmark"></i>
    </button>
</div>
